import React from "react";
import "./NavStrip.css";

function NavStrip() {
  return (
    <div className="news-strip">
      <p>🌞 Latest Offer: Get 20% Off on Commercial Solar Installation | Call Us Today! | Save Energy, Save Money!</p>
    </div>
  );
}

export default NavStrip;
